// @tenorlab/vue-dashboard-pro
// file: src/other-widgets/other-widgets-meta.ts
import type { TDashboardWidgetKey, TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { CircleQuestionMarkIcon as GeneralWidgetIcon } from '@tenorlab/vue-dashboard'
import { markRaw } from 'vue'
import { PanelRight as ContainerWidgetIcon } from 'lucide-vue-next'

// look up for other widgets information
export const otherWidgetsMetaMap: Record<TDashboardWidgetKey, TWidgetMetaInfo> = {
  // provide meta information for containers:
  WidgetContainer: {
    name: 'Container',
    categories: ['Container'],
    icon: markRaw(ContainerWidgetIcon),
    description: 'A container that can contain other widgets in a column.',
    externalDependencies: [],
  },
  WidgetContainerRow: {
    name: 'Row Container',
    categories: ['Container'],
    icon: markRaw(ContainerWidgetIcon),
    description: 'A container that can contain other widgets and displays them in a responsive row.',
    externalDependencies: [],
  },
  WidgetContainerLarge: {
    name: 'Large Container',
    categories: ['Container'],
    icon: markRaw(ContainerWidgetIcon),
    description: 'A larger container that can contain other widgets and displays them in a 2-column grid.',
    externalDependencies: [],
  },
  // if you want, you can add static meta here for other widgets
  WidgetSmallCardTransparentSample1: {
    name: 'Small Card Sample 1 (transparent)',
    categories: ['Widget'],
    icon: markRaw(GeneralWidgetIcon),
    noDuplicatedWidgets: true,
    description: 'A small-card widget sample (transparent).',
    externalDependencies: [],
  },
  WidgetSmallCardTransparentSample2: {
    name: 'Small Card Sample 2 (transparent)',
    categories: ['Widget'],
    icon: markRaw(GeneralWidgetIcon),
    noDuplicatedWidgets: true,
    description: 'A small-card widget sample (transparent).',
    externalDependencies: [],
  },
  WidgetSmallCardTransparentSample3: {
    name: 'Small Card Sample 3 (transparent)',
    categories: ['Widget'],
    icon: markRaw(GeneralWidgetIcon),
    noDuplicatedWidgets: true,
    description: 'A small-card widget sample (transparent).',
    externalDependencies: [],
  },
  WidgetSmallCardTransparentSample4: {
    name: 'Small Card Sample 4 (transparent)',
    categories: ['Widget'],
    icon: markRaw(GeneralWidgetIcon),
    noDuplicatedWidgets: true,
    description: 'A small-card widget sample (transparent).',
    externalDependencies: [],
  },
  WidgetSmallCardTransparentSample5: {
    name: 'Small Card Sample 5 (transparent)',
    categories: ['Widget'],
    icon: markRaw(GeneralWidgetIcon),
    noDuplicatedWidgets: true,
    description: 'A small-card widget sample (transparent).',
    externalDependencies: [],
  },
}
